import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
export class ResizeArbetsorderOperationCommand extends BasicCommand<ResizeArbetsorderOperationCommand> {
    get primaryKey(): IPrimaryKey<ResizeArbetsorderOperationCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    maskinlagId: number;
    startdatum: Date;
    slutdatum: Date;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ResizeArbetsorderOperationCommand";
    constructor(init: (instance: ResizeArbetsorderOperationCommand) => void) {
        super(ResizeArbetsorderOperationCommand.$type, ResizeArbetsorderOperationCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
